import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";

const ADMIN_ROLES = ["admin", "super_admin"];

export default function ProtectedRoute() {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#FAFAF5]" data-testid="admin-auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#D84315] border-t-transparent" />
      </div>
    );
  }
  if (!user || !ADMIN_ROLES.includes(user.role)) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
}
